import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {MøteModellEnkel} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {lesZonedDateTimeSerialisert} from "felles-ng2/støttefunksjoner/temporal";
import {TemporalFormatering} from "felles-ng2/tjenester/TemporalFormatering";
import {GjeldendeTidssone} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {gruppefargeNilsikker} from "felles-ng2/modell/Gruppefarge";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";

const debug = initDebugger('MøteKortvisningMiniKomponent');

/**
 * Kortvisning av møte i mini-format.
 */
@Component({
    selector: 'moete-kortvisning-mini',
    templateUrl: 'moete-kortvisning-mini.html',
    styleUrl: 'moete-kortvisning-mini.scss',
    imports: [],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteKortvisningMiniKomponent {

    moete = input.required<MøteModellEnkel>();
    datoformat = input<'kort' | 'langt'>('kort');

    moetedato = computed(() => this.møtedato());
    gruppefarge = computed(() => this.farge());

    constructor(private temporalFormatering: TemporalFormatering, private gjeldendeTidssone: GjeldendeTidssone, private kontekst: BrukerkontekstTilbyder) {

    }

    //private hjelpemetoder

    private møtedato(): string {
        const dato = lesZonedDateTimeSerialisert(this.moete().dato.start)
          .withTimeZone(this.gjeldendeTidssone.brukersTidssone().somZoneId())
          .toPlainDate();

        switch (this.datoformat()) {
            case 'langt':
                return this.temporalFormatering.formaterPlainDate(dato, {month: 'short', weekday: 'short', day: 'numeric'})
            case 'kort':
            default:
                return this.temporalFormatering.formaterPlainDate(dato, {weekday: 'short', day: 'numeric'})
        }
    }

    private farge(): string {
        const gruppe = this.kontekst.autentisertBruker().finnAutentiserteGruppe(this.moete().eiendeGruppeId);
        return gruppefargeNilsikker(gruppe).rammeFarge;
    }
}
